angular.module('app.filters').filter('parseKey', () => (model, key) => {
    const parts = (key || '').split('.');
    let target = angular.copy(model);
    let found = false;

    for (let i = 0; i < parts.length; ++i) {
        if (target && 'undefined' !== typeof target[parts[i]]) {
            target = target[parts[i]];
            found = true;
        }
    }

    return found ? target : key;
});
